import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/user-context";
import { AuthContext } from "../contexts/auth-context";

export default function useLocaleSaver() {
  const { i18n, t } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);
  const { user, setLanguage } = useContext(UserContext);
  const [languageLoadedFromApi, setLanguageLoadedFromApi] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    if (
      (languageLoadedFromApi && user.language !== i18n.language) ||
      user.language == null
    ) {
      const updateUserLanguage = async () => {
        await setLanguage(i18n.language);
        setLanguageLoadedFromApi(true);
      };
      updateUserLanguage().catch(console.error);
    } else if (user.language !== i18n.language) {
      i18n.changeLanguage(user.language);
    }
    if (user.language) setLanguageLoadedFromApi(true);
  }, [i18n, t, user, isAuthenticated, setLanguage, languageLoadedFromApi]);

  useEffect(() => {
    if (!isAuthenticated) setLanguageLoadedFromApi(false);
  }, [isAuthenticated]);
}
